export enum DonorPreselectBulkUpdateType {
    Decision = 1,
    Review = 2
}